import { FC } from "react";
import clsx from "clsx";
import styles from "./TopAnalystConsensusStocks.module.scss";

export interface StockData {
    symbol: string;
    price: number;
    change: number;
    changePercent: number;
    companyName: string;
}

interface ITopAnalystConsensusStocksProps {
    data: StockData[];
    isTradeOrderViewOpen: boolean;
}

export const TopAnalystConsensusStocks: FC<ITopAnalystConsensusStocksProps> = ({
    isTradeOrderViewOpen,
    data,
}) => {
    return (
        <section className={styles.container}>
            <ul className={styles.stocks}>
                {data.slice(0, 5).map((stock, index) => (
                    <li
                        key={index}
                        className={clsx(styles.stock, {
                            [styles.smHeight]: !isTradeOrderViewOpen,
                        })}>
                        <header className={styles.symbolPrice}>
                            <strong className={styles.symbol}>{stock.symbol}</strong>
                            <span className={styles.price}>${stock.price}</span>
                        </header>

                        <div className={styles.changePrice}>
                            <p className={styles.companyName}>{stock.companyName}</p>
                            <div
                                className={clsx(styles.changeValue, {
                                    [styles.negative]: stock.change < 0,
                                    [styles.row]: !isTradeOrderViewOpen,
                                })}>
                                <span>{`$${stock.change}`}</span>
                                <span>{`(${stock.changePercent}%)`}</span>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};
